import { $api } from '#/api/client'
import { extractIdFromIri } from '#/utils/extractIdFromIri'
import type { IAnnouncement } from '#interfaces/announcement'
import { isAnnouncementStatus, isAnnouncementVariant } from '#interfaces/announcement'

interface IFetchAnnouncementsResponse {
  announcements: IAnnouncement[]
  isLoading: boolean
  isError: boolean
}

export const useFetchAnnouncements = (enabled: boolean = true): IFetchAnnouncementsResponse => {
  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/announcements',
    {},
    {
      enabled,
      select: (response): IAnnouncement[] =>
        response.member.map(
          (item): IAnnouncement => ({
            id: extractIdFromIri(item['@id']),
            message: item.message,
            variant: isAnnouncementVariant(item.variant) ? item.variant : 'info',
            status: isAnnouncementStatus(item.status) ? item.status : 'ended',
            companyId: item.company?.id ?? null,
            companyName: item.company?.name ?? null,
            startsAt: item.startsAt,
            endsAt: item.endsAt,
            createdByName: item.createdBy?.displayName ?? null,
            createdAt: item.createdAt ?? '',
            updatedAt: item.updatedAt ?? '',
          }),
        ),
    },
  )

  return {
    announcements: data ?? [],
    isLoading,
    isError,
  }
}
